import { Injectable, Inject } from '@angular/core';
import { IAttendeeService } from './iattendee.service';
import { AttendeeSearchParams } from './attendee-search-params.model';
import { AttendeeSearchResult } from './attendee-search-result.model';
import { ApiService, UtilService, PagedSearch, PagedResult } from '../../../shared/index';
import { AttendedFlagOrUnflag } from './attended-flag-or-unflag.model';
import { AssignAttendeeTable } from './assign-attendee-table.model';
import { UpdateAttendeeCustomFields } from './update-attendee-custom-fields.model';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Injectable()
export class AttendeeService implements IAttendeeService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService, private _navigationService: NavigationService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }
  public searchAttendees = (searchParams: AttendeeSearchParams): Promise<AttendeeSearchResult> => {
    let url = 'Event/' + searchParams.EventId.toString() + '/Attendees';
    return this._apiService.postPaged(url, searchParams).then((data: AttendeeSearchResult) => {
      //for (let reg of data.Result) {
      //    reg.ShowDetails = false;
      //    reg.LoadingDetails = false;
      //    reg.Selected = false;
      //}

      return Promise.resolve(data);
    });
  };

  public exportAttendees = (eventId: number): Promise<string> => {
    let url = 'Event/' + eventId.toString() + '/Attendees/Export';
    return this._apiService.get(url);
  };

  public exportAttendeesExtended = (eventId: number): Promise<string> => {
    let url = 'Event/' + eventId.toString() + '/Attendees/Export/Extended';
    return this._apiService.get(url);
  };

  public exportAttendeesExtendedAsExcel(eventId: number): Promise<string> {
    return this._apiService.get(`Event/${eventId}/Attendees/Export/Extended/Excel`);
  }

  public exportAttendeesExtendedAndFiltered = (eventId: number, attendeeIds: Array<number>): Promise<string> => {
    let url = 'Event/' + eventId.toString() + '/Attendees/Export/Extended/Filtered';
    return this._apiService.post(url, attendeeIds);
  };

  //public exportAttendees = (searchParams: AttendeeSearchParams): Promise<string> => {

  //    let url = "Event/" + searchParams.EventId.toString() + "/Attendees/Export";
  //    return this._apiService.postPaged(url, searchParams);

  //}

  public updateAttendedFlag = (attendeeIds: Array<number>, attended: boolean): Promise<void> => {
    let url = 'EventAttendees/FlagAsAttended';
    if (attended == false) {
      url = 'EventAttendees/FlagAsNotAttended';
    }
    return this._apiService.post(url, attendeeIds);
  };

  public updateAttendedFlagForEventItems = (dto: AttendedFlagOrUnflag): Promise<void> => {
    let url = 'EventAttendees/FlagEventItemsAsAttendedOrNotAttended';

    return this._apiService.post(url, dto);
  };
  //Event/{id:INT}/AttendeeIds
  public getAttendeeHeaderIdsForEvent = (eventId: number, searchParams: AttendeeSearchParams): Promise<Array<number>> => {
    let url = 'Event/' + eventId.toString() + '/AttendeeIds';
    return this._apiService.post(url, searchParams);
  };

  public printOpenInvoices = (eventId: number): void => {
    //https://jondevqanhcoc.wliinc29.com/external/wcpages/v12/webclient/report/report.aspx?reportname=InvoicesWhereClauseParam.rpt&EventID=153
    let url =
      this._navigationService.getLegacyDomain() +
      '/external/wcpages/v12/webclient/report/report.aspx?reportname=private_Events_NameBadge_Avery5383&recordselection=%7bEventList.EventID%7d+in+%5b' +
      eventId.toString() +
      '%5d';
    window.open(url);
  };

  public getProfileIdsForAttendeeHeaderIds = (attendeeHeaderIds: Array<number>): Promise<Array<number>> => {
    let url = 'EventAttendees/GetProfileIds';
    return this._apiService.post(url, attendeeHeaderIds);
  };

  public assignAttendeesToTable = (assignAttendeeTable: AssignAttendeeTable): Promise<void> => {
    let url = 'EventAttendees/AssignTable';
    return this._apiService.post(url, assignAttendeeTable);
  };

  public updateAttendeesCustomFields = (updateAttendeeCustomFields: UpdateAttendeeCustomFields): Promise<void> => {
    let url = 'EventAttendees/UpdateCustomFields';
    return this._apiService.post(url, updateAttendeeCustomFields);
  };
}
